module.exports = __webpack_public_path__ + "static/sokrates-a4c865fa6c235cc1cf091fb160311784.png";